import Vue from 'vue'

const ToastBus = new Vue()

export const showToastEvent = 'showToast'
export const hideToastEvent = 'hideToast'

export function showToast(icon, color, msg, wait = 0, dismissable = false) {
    const time = Date.now()
    ToastBus.$emit(showToastEvent, {
        icon,
        color,
        msg,
        time,
        wait,
        dismissable,
    })
    return time
}

export function hideToast(time) {
    ToastBus.$emit(hideToastEvent, { time })
}

export default ToastBus
